/**
 * @ngdoc service
 * @name checkins.factory:showPicklistContacts
 *
 * @description
 *
 */
angular
    .module('festzelt-os.picklists')
    .factory('showPicklistContacts', [
        '$state',
        showPicklistContacts
    ]);

function showPicklistContacts($state) {
    return {
        key: 'show-picklist-contacts',
        title: 'Contacts',
        level: 'row',
        action: function ({row}, store) {
            $state.go('app.picklists.contacts.index', {pid: row.id});
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/picklists/workflows/list/show-picklist-contacts.js